var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReportblack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Color",
    d: "M13.444,20H2.555A2.531,2.531,0,0,1,0,17.5V2.5A2.531,2.531,0,0,1,2.555,0h7A1,1,0,0,1,10.3.328l5.444,6A1,1,0,0,1,16,7V17.5A2.531,2.531,0,0,1,13.444,20ZM2.555,2A.531.531,0,0,0,2,2.5v15a.531.531,0,0,0,.555.5H13.444A.531.531,0,0,0,14,17.5V8H10.714A2.788,2.788,0,0,1,8,5.15V2ZM10,3V5.156A.815.815,0,0,0,10.781,6H13Zm1,13H5a1,1,0,1,1,0-2h6a1,1,0,1,1,0,2ZM8,12H5a1,1,0,1,1,0-2H8a1,1,0,0,1,0,2Z",
    transform: "translate(0 0)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(4601 3111)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Color-2",
    "data-name": "Color",
    d: "M13.444,20H2.555A2.531,2.531,0,0,1,0,17.5V2.5A2.531,2.531,0,0,1,2.555,0h7A1,1,0,0,1,10.3.328l5.444,6A1,1,0,0,1,16,7V17.5A2.531,2.531,0,0,1,13.444,20ZM2.555,2A.531.531,0,0,0,2,2.5v15a.531.531,0,0,0,.555.5H13.444A.531.531,0,0,0,14,17.5V8H10.714A2.788,2.788,0,0,1,8,5.15V2ZM10,3V5.156A.815.815,0,0,0,10.781,6H13Zm1,13H5a1,1,0,1,1,0-2h6a1,1,0,1,1,0,2ZM8,12H5a1,1,0,1,1,0-2H8a1,1,0,0,1,0,2Z",
    transform: "translate(-4601 -3111)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportblack);
export default __webpack_public_path__ + "static/media/reportblack.757e4b00.svg";
export { ForwardRef as ReactComponent };